export default __webpack_public_path__ + "static/media/heco.6d49c018.svg";